/* eslint-disable no-unused-vars */
import { APIBaseURL } from "../Environment/Environment";

const API_URL = {
  LOGIN: APIBaseURL + "login",
  LOGIN_AS_GUEST: APIBaseURL + "guest-login",
  REGISTER: APIBaseURL + "registration",
  VERIFY_OTP: APIBaseURL + "verifyOtp",
  Forget_Password: APIBaseURL + "forgot_password",
  Reset_Password: APIBaseURL + "reset_password",
  SubscribeNow: APIBaseURL + "subscribeNow",

  MY_PROFILE: APIBaseURL + "user-detail",
  UPDATE_PROFILE: APIBaseURL + "user-update",

  CHANGE_PASSWORD: APIBaseURL + "changePasswordWeb",

  GET_SHIPPING_DETAILS: APIBaseURL + 'get-billing-shipping-address',
  UPDATE_SHIPPING_DETAILS: APIBaseURL + "add-billing-shipping-address",
  GET_COUNTRY_LIST: APIBaseURL + 'countrylist',
  GET_STATE_LIST: APIBaseURL + 'statelist',


  GET_QUESTIONS_LIST: APIBaseURL + "questionList",
  GET_GIFTCARDS_LIST: APIBaseURL + "gift_cards_list",

  CONTACT_US: APIBaseURL + 'contact-us',

  GET_LAYOUT_LIST: APIBaseURL + "layout-list",

  GET_SINGLEPANELSIZE_LIST: APIBaseURL + 'single_panel',
  GET_SPLITCANVASSIZE_LIST: APIBaseURL + 'splitcanvas',
  GET_GALLERYWALLSIZE_LIST: APIBaseURL + 'gallery_walls',
  GET_STORYCANVAS_LIST: APIBaseURL + 'story-canvas',
  GET_ROLLEDTUBESIZE_LIST: APIBaseURL + 'rolledtube_list',
  GET_ARTTRAY_LIST: APIBaseURL + 'get_artplexiWood',

  GET_EDGE_LISTING: APIBaseURL + 'admin/edgeListingList',
  GET_FRAMED_EDGE_LISTING: APIBaseURL + 'admin/frameListingList',
  GET_SERVICES_LISTING: APIBaseURL + 'typeadditionalDigitalList',

  ADD_TO_CART: APIBaseURL + 'added-to-cart',
  ADD_GIFT_CARD: APIBaseURL + 'addGiftCard',
  GET_CART_LIST: APIBaseURL + 'get_cart_user',
  DELETE_CART_ITEM: APIBaseURL + 'permanent-delete',
  UPDATE_CART_QUANTITY: APIBaseURL + 'update_cart_ById',

  APPLY_PROMO_CODE: APIBaseURL + 'couponcheck',
  Checkout: APIBaseURL + 'checkout',
  CHECK_GUEST_CONTACT_DETAILS: APIBaseURL + 'check-guest-user',

  GET_ORDER_LIST: APIBaseURL + 'get-order-for-user',
  GET_ORDER_DETAIL: APIBaseURL + 'order_details',
  CANCEL_ORDER: APIBaseURL + 'order_status',

  GET_PAYMENT_LIST: APIBaseURL + 'get-payment_history-by-user',

  GET_PRUDUCTS_LIST: APIBaseURL + 'product-list',
  GET_PRUDUCT_DETAIL: APIBaseURL + 'product-details',

  GET_SUGGESTED_PRODUCTS: APIBaseURL + 'suggestionsProduct',

  GET_BRAINTREE_PAYMENT_TOKEN: APIBaseURL + 'client_token',

  // Affiliate apis---
  AFFILIATE_SIGNUP: APIBaseURL + 'affiliate/register',

  TRACK_ORDER: APIBaseURL + 'track-order',


};

function GET_SIZE_LIST(id) {
  // console.log(id)
  return APIBaseURL + `layout-size-list?id=${id}`
}



export { API_URL, GET_SIZE_LIST };
